module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agentWhiteListHolder"
  }, [_c('div', {
    staticClass: "errorHolder"
  }, [(_vm.selectedAgents.length == 0) ? _c('div', {
    staticClass: "color-6"
  }, [_vm._v("Select at least one agent")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mb-1 w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "glued-right w-100",
    attrs: {
      "type": "text",
      "placeholder": "Search agent name"
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 w-100 dark fs-small"
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.selectAll(true)
      }
    }
  }, [_vm._v("All")]), _vm._v(" | "), _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.selectAll(false)
      }
    }
  }, [_vm._v("None")])]), _vm._v(" "), _c('ul', {
    staticClass: "agentList"
  }, _vm._l((_vm.allAgents), function(agent) {
    return _c('li', [_c('checkbox', {
      on: {
        "input": _vm.agentSelectedChanged
      },
      model: {
        value: (agent.selected),
        callback: function($$v) {
          _vm.$set(agent, "selected", $$v)
        },
        expression: "agent.selected"
      }
    }, [_c('span', [_vm._v("\n                    " + _vm._s(agent.brandName) + "\n                ")])])], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "glued-left bg-lighter"
  }, [_c('i', {
    staticClass: "ico ico-search m-0 fs-normal color-1"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4dcdfa48", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dcdfa48"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/AgentWhiteList.vue
// module id = 940
// module chunks = 0